import { useEffect } from 'react';
import useUserStore from '@/stores/UserStore';
import { useAbly, useConnectionStateListener } from 'ably/react';
import { useShallow } from 'zustand/react/shallow';

import { trackAblyConnectionStatusChange } from '@/lib/analytics-event';

const AblyManager = () => {
  const { customerId, setAblyConnectionStatus } = useUserStore(
    useShallow((state) => ({
      customerId: state.customerId,
      setAblyConnectionStatus: state.setAblyConnectionStatus,
    }))
  );
  const client = useAbly();

  // Connect to Ably client when the customer details are available
  useEffect(() => {
    if (customerId) {
      client.connect();
    }

    return () => {
      client.close();
    };
  }, [client, customerId]);

  useConnectionStateListener(
    ['connected', 'disconnected', 'suspended', 'closed', 'failed'],
    (stateChange) => {
      setAblyConnectionStatus(stateChange.current);
      trackAblyConnectionStatusChange(stateChange.current);
    }
  );

  return null; // This component does not render anything
};

export default AblyManager;
